import { USER } from "../../../../pool";
import axiom from "../../../../utils/axiom";

export const updateClientDetails = (details) =>
  axiom.patch(USER.base + USER.paths.updateClientDetails, details);
